import { render } from "./Title1App.vue?vue&type=template&id=84be9fde"
import script from "./Title1App.vue?vue&type=script&lang=js"
export * from "./Title1App.vue?vue&type=script&lang=js"

import "./Title1App.vue?vue&type=style&index=0&id=84be9fde&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__